var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 15,
    viewBox: "0 0 96 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 80,
    height: 8,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5L11 1L2.5 9.5L5 13.5L12 5Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 5L85 1L93.5 9.5L91 13.5L84 5Z",
    fill: "#B7B7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H85L84 5H12L11 1Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23922 11.1961C3.11547 10.5773 3.58876 10 4.2198 10H91.7802C92.4112 10 92.8845 10.5773 92.7608 11.1961L92.1608 14.1961C92.0673 14.6635 91.6569 15 91.1802 15H4.8198C4.34312 15 3.93271 14.6635 3.83922 14.1961L3.23922 11.1961Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 0C10.1489 0 9.89454 0.105357 9.70701 0.292893L0.707007 9.29289C0.0770423 9.92286 0.52321 11 1.41411 11H94.5857C95.4766 11 95.9228 9.92286 95.2928 9.29289L86.2928 0.292893C86.1053 0.105357 85.8509 0 85.5857 0H10.4141ZM84.9999 1H10.9999L2.9999 9H92.9999L84.9999 1Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTray);
export default __webpack_public_path__ + "static/media/tray.7632d4f396feb9fa321d8c308fd90b75.svg";
export { ForwardRef as ReactComponent };